///<reference path="skyward.base.global.js"/>
(
function (skyward, $, undefined) {
    "use strict";
    skyward.formTextEditor = skyward.formTextEditor || {};

    skyward.formTextEditor.launch = function (originalValue, module, object, relationshipPath, options) {
        /// <summary>
        /// Launch a form-text editor.
        /// </summary>
        /// <param name="originalValue" type="string">The form-text to display in the editor on startup.</param>
        /// <param name="module" type="string">The starting module for the 'fields' treebrowse<br/>Note: module, object, and relationshipPath also filter calculated fields list.</param>
        /// <param name="object" type="string">The starting object for the 'fields' treebrowse<br/>Note: module, object, and relationshipPath also filter calculated fields list.</param>
        /// <param name="relationshipPath" type="string">The path to prepend to fieldnames selected from the treebrowse.<br/>Note: module, object, and relationshipPath also filter calculated fields list.</param>
        /// <param name="options" type="object">An object containing any of the following parameters: <br/>
        ///     prompts: (PromptsModel) prompts model to include in the prompts-list.<br/>note: Prompts list will be hidden if no value is provided<br/>
        ///     calculatedFields: (CalculatedFields_Model) calculated fields to include in the calculated fields list.<br/>note: List will be hidden if no value is provided<br/>
        /// </param>
        /// <returns>A promise which is either resolved with (data: friendlyValue }) if the popup is saved, or rejected if the popup is cancelled.</returns>
        /// <remarks>Prompt and Calculated Field bindings are returned in *friendly name* format and must be converted by the calling code before unbinding can occur</remarks>
        var deferred = $.Deferred();
        relationshipPath = relationshipPath || "";
        var calculatedFields = (options.calculatedFields) ? JSON.stringify(options.calculatedFields.AllFields()) : null;
        var prompts = (options.prompts) ? options.prompts.toJsonString() : null;
        var aggregateFields = options.aggregateFields ? JSON.stringify(options.aggregateFields) : null;

        var showPopup = function (jsonResult) {
            var popup;
            var textArea;
            var tabs;
            var activeTab = $();
            var fieldContainers = $();

            // Create a friendly-name converter delegate based on whether or not we were provided prompts and/or calculated fields
            var doNothing = function (s) { return s; };
            var convertPromptsToFriendlyNames = (typeof options.prompts.ConvertPromptBindingsToFriendlyNames === "function") ? options.prompts.ConvertPromptBindingsToFriendlyNames : doNothing;
            var convertCalculatedFieldsToFriendlyNames = (typeof options.calculatedFields.ConvertBindingsToFriendlyNames === 'function') ? options.calculatedFields.ConvertBindingsToFriendlyNames : doNothing;
            var convertToFriendlyNames = function (s) { return convertCalculatedFieldsToFriendlyNames(convertPromptsToFriendlyNames(s)); };


            var saveAndClose = function () {
                var result = textArea.val();
                popup.close();
                deferred.resolve(result);
            };
            var cancelAndClose = function () {
                popup.close();
                deferred.reject();
            }

            var selectActiveTab = function (event) {
                var tab = $(this);
                if (!tab.is(activeTab)) {
                    activeTab.removeClass("active").data('jqRelatedElements').addClass("hidden");
                    tab.addClass("active").data('jqRelatedElements').removeClass("hidden");
                    activeTab = tab;
                }
                event.stopPropagation;
                return false;
            }

            var insertField = function (fieldName) {
                skyward.global.text.insertTextToken(textArea, convertToFriendlyNames("{" + fieldName + "}"));
            }
            var insertCustomField = function () {
                insertField($(this).data('fieldBinding'));
            }
            var insertTreeBrowseField = function (event, _treeBrowseData, selectedRecordData) {
                var fullFieldName = selectedRecordData.absoluteFieldPath;
                insertField(fullFieldName);
                event.stopPropagation();
                return false;
            }


            var buttons = [
                { text: "Save", click: saveAndClose, icon: "Save" },
                { text: "Cancel", click: cancelAndClose, icon: "Cancel" }
            ];
            popup = skyward.modalLayer.showDialog("Form Text Editor", jsonResult.html, buttons, { width: "953px", closeOnClick: false, automationID: "form-text-dialog" });
            popup.bodyPromise.done(function () {
                textArea = popup.content.find(".fteTextArea");
                textArea.val(originalValue).focus();

                tabs = popup.content.find(".fteTab");
                tabs.each(function getFieldContainers() {
                    var data = $(this).data();
                    data.jqRelatedElements = popup.content.find(data.relatedElements);
                    fieldContainers = fieldContainers.add(data.jqRelatedElements);
                });

                activeTab = tabs.filter(".active");
                tabs.on("click", selectActiveTab);

                fieldContainers.on('dblclick', '.fteField', insertCustomField);
                popup.content.on("treeBrowseSave", insertTreeBrowseField);
            });
        };

        $.ajax(skyward.global.virtualDir + "Common/FormTextEditor/GetPopup",
        {
            type: "POST",
            dataType: "JSON",
            data: {
                module: module,
                obj: object,
                relationshipPath: relationshipPath,
                prompts: prompts,
                calculatedFields: calculatedFields,
                aggregateFields: aggregateFields
            }
        }).done(showPopup);

        return deferred;
    }
}(window.skyward = window.skyward || {}, window.jQuery)
);